<form id="filter" [formGroup]="formGroup">
  <div class="modal-top"></div>
  <ion-content id="content-window" [scrollY]="false">
    <div class="filter-container">
      <div class="filter-title">
        <ion-label translate>{{
          'i18n.search.searchFilters.filters'
        }}</ion-label>
        <div
          *ngIf="selectedFacetFilters?.length > 0"
          class="filter-number-pill"
        >
          <span>
            {{ selectedFacetFilters.length }}
          </span>
        </div>
      </div>
      <div class="filter-content">
        <div class="filters">
          <div class="filter-options">
            <h2 class="filter-header" translate>
              {{ 'i18n.common.filterBy' }}
            </h2>
            <ion-item
              *ngFor="let facet of facets"
              detail
              [class.selected]="selectedFacet === facet"
              (click)="setSelectedFacet(facet)"
            >
              <div class="label-wrapper">
                <ion-label class="filter-option">
                  {{ facet.label | titlecase }}
                </ion-label>
                <ion-label class="selected-filters-number">
                  {{ appliedFacetValueLabelsMap.get(facet.fieldName) }}
                </ion-label>
              </div>
            </ion-item>
          </div>
        </div>
        <ng-container *ngFor="let facet of facets">
          <app-facet-value-list
            *ngIf="selectedFacet === facet"
            class="facet-value-list"
            [facet]="selectedFacet"
            [formGroup]="$any(facetFormGroup.controls[selectedFacet.fieldName])"
            (clearSelectedFacetValue)="setSelectedFacet(null)"
          >
          </app-facet-value-list>
        </ng-container>
      </div>
    </div>
  </ion-content>
  <ion-content>
    <div class="modal-footer">
      <ion-button
        class="filter-button usf-outline-green-dsktp-tblt-modal-button"
        translate
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' }}
      </ion-button>

      <ion-button
        class="filter-button usf-fill-green-dsktp-tblt-modal-button"
        translate
        (click)="apply()"
      >
        {{ 'i18n.common.apply' }}
      </ion-button>
    </div>
  </ion-content>
</form>
